export default  {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    propertylist: '<'
  },
  controller: 'propertySelectController',
  template: require('../views/property.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.select.component.js